import { useState } from 'react'
import { Link } from 'react-router-dom'

// eslint-disable-next-line react/prop-types
const NotificationList = ({
  toggleNotifications,
  notifications,
  total = 0,
}) => {
  const [arrNotifications] = useState(notifications || [])

  const handleClick = (item) => () => {
    console.log({ item })
    toggleNotifications()
  }

  return (
    <div className="notificationHb">
      <div className="notificationHb-top">
        Notification <span>{total}</span>
      </div>
      <div className="notificationHb-content">
        {arrNotifications.map((x, i) => (
          <div key={i} className="notificationHb-item">
            <a
              href="#"
              onClick={handleClick(i)}
              className="notificationHb-user"
            >
              <img src={x.pic} alt="" />
            </a>
            <span className="notificationHb-name">
              <b>{x.type}:</b> {x.msg}
            </span>
            <span className="notificationHb-time">{x.time}</span>
          </div>
        ))}
      </div>
      <div className="notificationHb-bottom">
        <Link onClick={toggleNotifications} to="/notifications">
          See all
        </Link>
      </div>
    </div>
  )
}

export default NotificationList
